module.exports = __webpack_public_path__ + "img/medal4.7dbf14dc.svg";